import { useContext, useEffect, useReducer, useState } from "react";
import { Store } from "../Store";
import useAxios from "../hooks/useAxios";
import { getError } from "../utils";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default function useCompartments() {
  const axios = useAxios();
  const { dispatch: ctxDispatch, state } = useContext(Store);
  const { userInfo, compartments } = state;
  const [{ loading, error }, dispatch] = useReducer(reducer, {
    loading: false,
    error: "",
  });

  const [loadComparments, setLoadCompartments] = useState(false);

  const fetchCompartments = async () => {
    try {
      dispatch({ type: "FETCH_REQUEST", payload: {} });
      const { data } = await axios.get(`/api/compartments`);

      dispatch({ type: "FETCH_SUCCESS", payload: data });
      ctxDispatch({
        type: "COMPARTMENTS_UPDATED",
        payload: (data.compartments || []).sort(
          (a, b) => a.startNum - b.startNum
        ),
      });
    } catch (err) {
      dispatch({ type: "FETCH_FAIL", payload: getError(err) });
    }
  };

  useEffect(() => {
    if (userInfo && !compartments) {
      fetchCompartments();
    }
  }, [userInfo]);

  useEffect(() => {
    if (loadComparments) {
      fetchCompartments();
      setLoadCompartments(false);
    }
  }, [loadComparments]);

  return [loading, error, setLoadCompartments];
}
